var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivityWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4055_59547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55538 18.501V13.47L7.39719 11.4062L6.50202 15.3647L0.96875 14.2409L1.23058 12.9561L5.36809 13.8099L6.86341 6.19792L4.81448 7.02499V9.88116H3.52151V6.17788L6.94293 4.7291C7.37937 4.54679 7.70097 4.42612 7.9077 4.36707C8.11429 4.30788 8.30435 4.27829 8.4779 4.27829C8.74095 4.27829 8.98518 4.34761 9.21058 4.48624C9.43599 4.62502 9.61945 4.80991 9.76096 5.04093L10.6229 6.42009C10.9909 7.01242 11.4945 7.51079 12.1338 7.9152C12.7731 8.31961 13.4939 8.53841 14.2963 8.5716V9.86457C13.4199 9.83699 12.5729 9.6118 11.7552 9.18899C10.9373 8.76634 10.2399 8.1544 9.66312 7.35319L9.02159 10.594L10.8483 12.3512V18.501H9.55538ZM9.77087 3.49927C9.32997 3.49927 8.9545 3.34426 8.64448 3.03423C8.33445 2.72421 8.17944 2.34874 8.17944 1.90784C8.17944 1.46694 8.33445 1.09147 8.64448 0.781444C8.9545 0.471418 9.32997 0.316406 9.77087 0.316406C10.2118 0.316406 10.5872 0.471418 10.8973 0.781444C11.2073 1.09147 11.3623 1.46694 11.3623 1.90784C11.3623 2.34874 11.2073 2.72421 10.8973 3.03423C10.5872 3.34426 10.2118 3.49927 9.77087 3.49927Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4055_59547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityWhite);
export default __webpack_public_path__ + "static/media/activityWhite.36f8695e76bfea3b6bf9ed1806af3983.svg";
export { ForwardRef as ReactComponent };